//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

function FinancialSection() {
  return (
    <section
      id="financial-transparency-section"
      data-testid="financial-transparency-section"
      aria-label="Seção sobre a transparência financeira e repasses da plataforma"
      className={styles.financialSection}
    >
      <Container
        id="financial-container"
        data-testid="financial-container"
        aria-label="Container do financeiro e transparência"
        maxWidth="xl"
      >
        <ScrollTransition
          id="financial-title-transition"
          data-testid="financial-title-transition"
          aria-label="Animação do título do financeiro"
        >
          <h2
            id="financial-title"
            data-testid="financial-title"
            aria-label="Título: Financeiro X Transparência"
            className={styles.sectionTitle}
          >
            <span className={styles.highlight}>Financeiro</span> X Transparência
          </h2>
          <div
            id="financial-divider"
            data-testid="financial-divider"
            aria-label="Linha decorativa do financeiro"
            className={styles.divider}
          />
        </ScrollTransition>

        <ScrollTransition
          id="financial-table-transition"
          data-testid="financial-table-transition"
          aria-label="Animação da tabela de repasses e regras"
          delay={200}
        >
          <div
            id="table-responsive-wrapper"
            data-testid="table-responsive-wrapper"
            aria-label="Tabela responsiva de regras financeiras"
            className={styles.tableWrapper}
          >
            <table
              id="financial-rules-table"
              data-testid="financial-rules-table"
              aria-label="Tabela detalhada de formas de pagamento, disponibilidade e regras do repasse"
              className={styles.financialTable}
            >
              <thead
                id="financial-thead"
                data-testid="financial-thead"
                aria-label="Cabeçalho da tabela"
              >
                <tr
                  id="financial-header-row"
                  data-testid="financial-header-row"
                  aria-label="Linha do cabeçalho"
                >
                  <th
                    id="th-pagamento"
                    data-testid="th-pagamento"
                    aria-label="Coluna Forma de Pagamento"
                    className={styles.tableTh}
                  >
                    Pagamento
                  </th>
                  <th
                    id="th-disponibilidade"
                    data-testid="th-disponibilidade"
                    aria-label="Coluna Disponibilidade do Repasse"
                    className={styles.tableTh}
                  >
                    Disponibilidade
                  </th>
                  <th
                    id="th-regras"
                    data-testid="th-regras"
                    aria-label="Coluna Regras e Condições"
                    className={styles.tableTh}
                  >
                    Regras
                  </th>
                </tr>
              </thead>
              <tbody
                id="financial-tbody"
                data-testid="financial-tbody"
                aria-label="Corpo da tabela contendo regras de PIX, Crédito e Saques"
              >
                <tr
                  id="row-pix"
                  data-testid="row-pix"
                  aria-label="Linha com regras para pagamento por PIX"
                  className={styles.tableTr}
                >
                  <td
                    id="td-pix-pagamento"
                    data-testid="td-pix-pagamento"
                    aria-label="PIX"
                    className={styles.tableTdHighlight}
                  >
                    PIX
                  </td>
                  <td
                    id="td-pix-dispo"
                    data-testid="td-pix-dispo"
                    aria-label="Disponibilidade Imediata"
                    className={styles.tableTd}
                  >
                    Imediata
                  </td>
                  <td
                    id="td-pix-regras"
                    data-testid="td-pix-regras"
                    aria-label="Regras do PIX: Disponibilizado em até 2 horas após a confirmação de entrega do pedido pelo cliente."
                    className={styles.tableTd}
                  >
                    Disponível ao aceitar o pedido. Estorno automático se
                    cancelar.
                  </td>
                </tr>
                <tr
                  id="row-credito"
                  data-testid="row-credito"
                  aria-label="Linha com regras para pagamento por Crédito Direto"
                  className={styles.tableTr}
                >
                  <td
                    id="td-credito-pagamento"
                    data-testid="td-credito-pagamento"
                    aria-label="Crédito Direto"
                    className={styles.tableTdHighlight}
                  >
                    Crédito Direto
                  </td>
                  <td
                    id="td-credito-dispo"
                    data-testid="td-credito-dispo"
                    aria-label="Disponibilidade D+30 ou Antecipado"
                    className={styles.tableTd}
                  >
                    30 dias
                  </td>
                  <td
                    id="td-credito-regras"
                    data-testid="td-credito-regras"
                    aria-label="Regras do Crédito: Repasses automáticos em 30 dias, ou solicitação de antecipação mediante taxa fixa de administração."
                    className={styles.tableTd}
                  >
                    Liquidação segura via plataforma
                  </td>
                </tr>
                <tr
                  id="row-saques"
                  data-testid="row-saques"
                  aria-label="Linha com regras para saques e transferências"
                  className={styles.tableTr}
                >
                  <td
                    id="td-saques-pagamento"
                    data-testid="td-saques-pagamento"
                    aria-label="Saques"
                    className={styles.tableTdHighlight}
                  >
                    Saques
                  </td>
                  <td
                    id="td-saques-dispo"
                    data-testid="td-saques-dispo"
                    aria-label="Disponibilidade D+0 (Dias úteis)"
                    className={styles.tableTd}
                  >
                    A qualquer momento
                  </td>
                  <td
                    id="td-saques-regras"
                    data-testid="td-saques-regras"
                    aria-label="Regras de Saques: Transferências para contas vinculadas sem tarifas adicionais para o primeiro saque diário."
                    className={styles.tableTd}
                  >
                    Resgate o saldo para sua conta bancária cadastrada{" "}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ScrollTransition>
      </Container>
    </section>
  );
}

export default FinancialSection;
